import { Outlet } from '@tanstack/react-router';
import { useState } from 'react';

import { MaintenanceBanner } from '@/components/molecules/MaintenanceBanner';
import Sidebar from '@/components/organism/Sidebar';
import { isLargeScreen, useWindowDimensions } from '@/hooks/useWindowDimensions';

import { MobileHeader } from './MobileHeader';

export const RootLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { width } = useWindowDimensions();
  const isLargerScreen = isLargeScreen(width);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <main className='flex h-screen flex-col'>
      {/* Mobile Header - Only visible on small screens */}
      <MobileHeader onToggleSidebar={toggleSidebar} />
      <MaintenanceBanner />
      <section className='flex min-h-0 flex-1'>
        {/* Only render sidebar when open on mobile OR always on large screens */}
        {(isSidebarOpen || isLargerScreen) && (
          <Sidebar isOpen={isSidebarOpen} onToggle={setIsSidebarOpen} />
        )}
        <div className='dark:bg-c0 min-h-0 flex-1 overflow-y-auto'>
          <Outlet />
        </div>
      </section>
    </main>
  );
};
